"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketToJSON = exports.TicketFromJSONTyped = exports.TicketFromJSON = exports.instanceOfTicket = void 0;
var CcAgent_1 = require("./CcAgent");
var TicketStatus_1 = require("./TicketStatus");
/**
 * Check if a given object implements the Ticket interface.
 */
function instanceOfTicket(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "requester" in value;
    isInstance = isInstance && "requesterAgent" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "canSolve" in value;
    isInstance = isInstance && "canReply" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "cc" in value;
    isInstance = isInstance && "ccAgent" in value;
    return isInstance;
}
exports.instanceOfTicket = instanceOfTicket;
function TicketFromJSON(json) {
    return TicketFromJSONTyped(json, false);
}
exports.TicketFromJSON = TicketFromJSON;
function TicketFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'status': (0, TicketStatus_1.TicketStatusFromJSON)(json['status']),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'requester': json['requester'],
        'requesterAgent': json['requesterAgent'],
        'subject': json['subject'],
        'description': json['description'],
        'canSolve': json['canSolve'],
        'canReply': json['canReply'],
        'type': json['type'],
        'cc': json['cc'],
        'ccAgent': (json['ccAgent'].map(CcAgent_1.CcAgentFromJSON)),
    };
}
exports.TicketFromJSONTyped = TicketFromJSONTyped;
function TicketToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': (0, TicketStatus_1.TicketStatusToJSON)(value.status),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'requester': value.requester,
        'requesterAgent': value.requesterAgent,
        'subject': value.subject,
        'description': value.description,
        'canSolve': value.canSolve,
        'canReply': value.canReply,
        'type': value.type,
        'cc': value.cc,
        'ccAgent': (value.ccAgent.map(CcAgent_1.CcAgentToJSON)),
    };
}
exports.TicketToJSON = TicketToJSON;
